<template>
  <div id="popupSingle">
    <a-modal :title="QueryUpdatas.pageTitle" v-model="visible" width="70%">
      <template slot="footer">
        <a-button type="primary" sizez="small" @click="closePopup">{{ $t('publicLang.Close') }}</a-button>
      </template>
      <div style="height: 60vh;overflow: hidden;overflow-y: auto;">
        <a-form>
          <a-row :gutter="24" style="border: 1px solid #efefef">
            <a-col :span="12" v-for="(item, index) in QueryUpdatas.data" style="border: 1px solid #efefef;">
              <span style="font-size: 12px;font-weight: 800"><a-icon type="info"  style="color: #409eff;"/>  {{item.label}}: </span>
              <span style="font-size: 12px;">{{item.DefaultValue == null ? "-" : item.DefaultValue}}</span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  props: {
    QueryUpdatas: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      }
    };
  },
  methods: {
    closePopup() {
      this.visible = false;
    },
    openPopup() {
      this.visible = true;
    }
  }
};
</script>
